export function withKey(key, element) {
    return { ...element, key };
}
//# sourceMappingURL=withKey.js.map